/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody, Table, Progress } from 'reactstrap';
import moment from 'moment';
import Joyride, { STATUS } from 'react-joyride';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import ChatService from '../../services/ChatService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import ClientNavbar from './ClientNavbar';
import SelectedProvider from './SelectedProvider';
import ClientService from '../../services/ClientService';
import Loading from '../../assets/UW_Horizontal_Logo_Full.png';
import Arrow from '../../assets/arrow.svg';
import FindProviderImg from '../../assets/active_support.svg';

const UpdateSubscription = props => {

    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);
    const { user, setUser, selectedTimeZone } = useContext(AuthContext);

    // states
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [availablePlans, setAvailablePlans] = useState([]);
    const [subscriptions, setSubscriptions] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState({});
    const [currentPlan, setCurrentPlan] = useState();
    const [currentSubscription, setCurrentSubscription] = useState(null);
    const [plansModal, setPlansModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <div className="tooltipDiv">This is your current Subsciption plan details.</div>,
                placement: 'right',
                target: '#currentPlanCard',
            },
            {
                content: <div className="tooltipDiv">Select other plan to which you want to update from here.</div>,
                placement: 'left',
                target: '#otherPlanCards',
            },
            {
                content: <div className="tooltipDiv">Once selected, process the payment by pressing here.</div>,
                placement: 'right',
                target: '#paymentBtn',
            }
        ]
    });
    let helpers = null;

    // useEffects
    useEffect(() => {
        setIsLoading(true);
        ClientService.selectedProvider()
            .then(selectedProvider => {
                try {
                    // console.log("data1", selectedProvider);
                    setSelectedProvider(selectedProvider);
                    ClientService.getSubscriptionPlans()
                        .then(subscriptionPlans => {
                            try {
                                // console.log("subscriptionPlans", subscriptionPlans.data);
                                ClientService.getSubscription()
                                    .then(subscription => {
                                        // console.log("subscription", subscription);
                                        try {
                                            if (subscription.data) {
                                                const tempCurrentPlan = subscriptionPlans.data.find(plan => plan.razorpayPlanId === subscription.data.clientSubscriptionPlan.razorpayPlanId && (plan.isActive));
                                                setCurrentSubscription(subscription.data);
                                                setCurrentPlan(tempCurrentPlan);
                                                setAvailablePlans(subscriptionPlans.data);
                                            }
                                            setIsLoading(false);
                                        } catch (err) {
                                            setIsLoading(false);
                                            // console.log("err", err);
                                            Alert.error("Some error occured, please try again later or report support team.", {
                                                position: 'top-right',
                                                effect: 'slide'
                                            });
                                            // GeneralService.logError('at BookSession useEffect2_1', err.stack);
                                        }
                                    });
                            } catch (err) {
                                setIsLoading(false);
                                // console.log("err2", err);
                                Alert.error("Some error occured, please try again later or report support team.", {
                                    position: 'top-right',
                                    effect: 'slide'
                                });
                                // GeneralService.logError('at BookSession useEffect2_1', err.stack);
                            }
                        });
                } catch (err) {
                    setIsLoading(false);
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    // GeneralService.logError('at Client BookSession useEffect2_1', 'Error in try catch block', err.stack);
                }
            });
    }, []);

    // handle functions
    const handlePlanSelect = e => {
        if (selectedPlan.id) {
            try {
                props.history.push({
                    pathname: "/client/makesubscriptionpayment",
                    state: {
                        selectedProvider: selectedProvider,
                        isUpdate: true,
                        selectedPlan: selectedPlan,
                        oldPlan: currentSubscription
                    }
                });
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {

                    position: 'top-right',
                    effect: 'slide'
                });
                // GeneralService.logError('at BookSession handleSubmit', err.stack);
            }
        }
    }

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            // if (!user.guideTakenFor.includes("ClientDashboard")) {
            //     AuthService.markVisited("ClientDashboard");
            //     setUser({ ...user, guideTakenFor: [...user.guideTakenFor, "ClientDashboard"] });
            // }
            // AuthService.markVisited("ClientDashboard");
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        <div id="updateSubscriptionDiv">
            <ErrorBoundary errorAt="At Client UpdateSubscription Joyride">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={false && tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={false}
                    showSkipButton={true}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
            </ErrorBoundary>
            <ClientNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    <div className="p-2">
                        <div>
                            <div className="text-center">
                                <h1 id="change-subscription-heading" style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.8rem", fontWeight: "500", color: "#384E73" }}>Change Subscription Plan</h1>
                                <h2 id="change-subscription-paragraph" style={{ fontFamily: "Montserrat, sans-serif", fontSize: "1.2rem", fontWeight: "500" }}>Your existing plan will be cancelled.<br />Refund will be processed for days left in your existing plan within 7 business days.</h2>
                            </div>
                            <div className="row pt-4">
                                <div id="currentPlanCard" className="col-12 col-md-3 text-center">
                                    <div className="newPlanListTitleDiv">
                                        <h2 id="current-subscription-plan" style={{ color: "#384E73", fontFamily: "Montserrat, sans-serif", fontSize: "1.4rem", fontWeight: "500" }}>Current Subscription</h2>
                                    </div>
                                    <div className="px-2 py-3 mx-md-0 mx-2" style={theme.disabledSlotCard}>
                                        <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{currentPlan.name}</h2>
                                        <p>{`₹${currentPlan.amount / 100} / ${currentPlan.period}`}</p>
                                        <div>
                                            <p><i className={`fas fa-${currentPlan.call > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>{`${currentPlan.call} Call Sessions / ${currentPlan.period}`}</p>
                                            <p><i className={`fas fa-${currentPlan.video > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>{`${currentPlan.video} Video Sessions / ${currentPlan.period}`}</p>
                                            <p><i className={`fas fa-${currentPlan.report ? 'check' : 'times danger_text_color'} mr-2`}></i>{`Report Included`}</p>
                                            <p><i className="fas fa-check mr-2"></i>{`Unlimited Messages`}</p>
                                        </div>
                                    </div>
                                </div>
                                <div id="planUpdateArrow" className="col-3 col-md-2 mx-auto"></div>
                                <div id="otherPlanCards" className="col-12 col-md-7 text-center">
                                    <div className="newPlanListTitleDiv">
                                        <h2 id="updateToHeading" style={{ color: "#384E73", fontFamily: "Montserrat, sans-serif", fontSize: "1.4rem", fontWeight: "500" }}>Update To</h2>
                                    </div>
                                    <div className="newPlanList row justify-content-between mx-0">
                                        {
                                            availablePlans.map((item, index) => (
                                                item.razorpayPlanId === currentSubscription.clientSubscriptionPlan.razorpayPlanId ? null :
                                                    <div id={`updateTo${index}`} key={index} className="col-md-5 col-11 text-center px-2 py-3 mb-3 mt-md-0 mt-1 mx-md-0 mx-2" style={selectedPlan.id == item.id ? theme.selectedSlotCard : theme.slotCard} onClick={() => setSelectedPlan(item)}>
                                                        <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{item.name}</h2>
                                                        <p>{`₹${item.amount / 100} / ${item.period}`}</p>
                                                        <div>
                                                            <p><i className={`fas fa-${item.call > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>{`${item.call} Call Sessions / ${item.period}`}</p>
                                                            <p><i className={`fas fa-${item.video > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>{`${item.video} Video Sessions / ${item.period}`}</p>
                                                            <p><i className={`fas fa-${item.report ? 'check' : 'times danger_text_color'} mr-2`}></i>{`Report Included`}</p>
                                                            <p><i className="fas fa-check mr-2"></i>{`Unlimited Messages`}</p>
                                                        </div>
                                                    </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="text-center">
                                <button className="btn mx-auto mt-4" id="paymentBtn" type="button" style={theme.button} onClick={() => handlePlanSelect()}>
                                    Continue Payment
                                </button>
                            </div>
                        </div>
                    </div>
            }
            <Modal size="lg" isOpen={plansModal} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setPlansModal(false)}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Subscription plans</span></ModalHeader>
                <ModalBody>
                    <div className="p-2">
                        <h3 style={theme.h3headingSemibold}>Select Plan</h3>
                        <div className="text-center mt-2" style={{ overflowX: "scroll", overflowY: "hidden", whiteSpace: "nowrap" }}>
                            {
                                availablePlans.map((item, index) => (
                                    <div key={index} className="d-inline-block col-8 col-sm-8 col-md-4 text-center px-2 py-3 m-3" style={selectedPlan.id == item.id ? theme.selectedSlotCard : theme.slotCard} onClick={() => setSelectedPlan(item)}>
                                        <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{item.name}</h2>
                                        <p>{`₹${item.amount / 100} / ${item.period}`}</p>
                                        <div>
                                            <p><i className={`fas fa-${item.call > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>{`${item.call} Call Sessions / ${item.period}`}</p>
                                            <p><i className={`fas fa-${item.video > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>{`${item.video} Video Sessions / ${item.period}`}</p>
                                            <p><i className="fas fa-check mr-2"></i>{`Unlimited Messages`}</p>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button type="button" style={theme.formButton} className="btn" disabled onClick={() => handlePlanSelect()}>
                        Proceed to Payment
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )

}

export default UpdateSubscription;